// Display types and formatters for Monitoring classification panes.
// Confidence / level / override derivation now lives in gcp-ara-api.

export type ConfidenceLabel = 'high_confidence' | 'low_confidence';

const CONFIDENCE_LABEL_DISPLAY: Record<ConfidenceLabel, string> = {
  high_confidence: 'High Confidence',
  low_confidence: 'Low Confidence',
};

export function formatConfidenceLabel(label: ConfidenceLabel): string {
  return CONFIDENCE_LABEL_DISPLAY[label];
}

export interface ClassificationLevelDetail {
  name: string;
  code: string;
  description: string;
  score: number | null;
}

export interface RecordClassificationEntry {
  classificationId: string;
  levels: [ClassificationLevelDetail, ClassificationLevelDetail, ClassificationLevelDetail];
  rankingScore: number | null;
  isSelected: boolean;
  note?: string;
}

export interface FunctionClassificationEntry {
  classificationId: string;
  levels: [ClassificationLevelDetail, ClassificationLevelDetail, ClassificationLevelDetail];
  rankingScore: number | null;
  isSelected: boolean;
}

/** Display a 0–1 ranking score as a percentage (e.g. 0.85 → 85.0%). */
export function formatScoreAsPercentage(score: number | null): string {
  if (score == null) return '—';
  const percent = score <= 1 ? score * 100 : score;
  return `${percent.toFixed(1)}%`;
}
